// extracted by mini-css-extract-plugin
module.exports = {"with-trailing":"WithTrailing_with-trailing__jFHiP","center":"WithTrailing_center__o4rRr"};